module.exports = {
  "level1": {
     "name": "実名",
     "idcard": "証明書の種類：",
     "address": "现住地址",
     "bank_number": "银行卡号",
     "wc": "決定する",
     "name_nodata": "姓名不能为空",
     "id_card_nodata": "证件号码不能为空",
     "address_nodata": "地址不能为空",
     "bank_number_nodata": "银行卡号不能为空",
     "input-username":"本名を入力してください",
     "zjhm":"ID番号",
     "input-idcard":"ID番号を入力してください",
     "input-address":"请输入地址",
     "zjlx":"証明書の種類",
     "qxzzjlx":"証明書の種類を選択してください",
     "sfz":"IDカード",
     "hz":"パスポート",
     "jsz":"驾驶证",
     "lxz":"留学证",
     "zfbzh": "支付宝账号",
     "qsrzfbzh": "请输入支付宝账号",
     "khh": "口座銀行",
     "qsrkhh": "口座銀行を入力してください",
     "yhkh": "銀行カード番号",
     "qsryhkh": "銀行カード番号を入力してください",
     "zfzh": "支付账户",
     "qxzzfzh": "请选择支付账户",
     "gjlb": "国のリスト",
     "qxzgjlb": "国/地域を選択してください"
   },
  "my":{
   "bindphone":"绑定手机",
   "gqrcode":"扫下面的二维码图案或输入推广码，确认注册",
   "mqrcode":"我的二维码",
   "as":"セットアップ",
   "pc":"一次認証",
   "ac":"二次認証",
   "smrz":"確認済み",
   "sfyz":"KYC認証",
   "mm":"我的资金",
   "ms":"我要分享",
   "me":"我的收益",
   "zsr":"总收入",
   "mp": "我的推广",
   "yqhy": "友達を招待",
   "ar":"記録",
   "hc":"ヘルプセンター",
   "nodata":"データなし",
   "med": "收益明细",
   "aes": "累積所得(USDT)",
   "one": "一代",
   "two": "二代",
   "three": "三代",
   "four": "四代",
   "ones": "一代人数",
   "twos": "二代人数",
   "threes": "三代人数",
   "fours": "四代人数",
   "promotion": "推广人数",
   "customers": "我的收益",
   "total": "合计(昨日)",
   "usdt": "USDT",
   "wdzc": "私の資産",
   "wdzc1": "私の資産",
   "wyfx": "我要分享",
   "wdsy": "我的收益",
   "wdtg": "我的推广",
   "zhjl": "記録",
   "fbjl": "法币记录",
   "zxkf": "オンラインサービス",
   "wdxx": "私のメッセージ"
  },
 "footer":{
   "home":"ホーム",
   "quotation":"マーケット",
   "currency":"通貨取引",
   "lever":"契約",
   "assets":"残高",
   "my":"アカウント",
   "lc": "財務管理"
 },
 "index":{
   "wdzc":"私の資産 (USDT)",
   "xsbk":"新手必看",
   "dlhkck":"登录后可以查看",
   "dl":"ログイン後に表示",
   "zxkf":"オンラインサービス",
   "function":"功能服务",
   "legal":"法币交易",
   "legaltxt":"用法定货币购买数字资产",
   "levertxt":"数倍于原始资金的的投资",
   "c2c":"c2c交易",
   "c2ctxt":"双向交易 套期保值",
   "increase":"リストを増やす",
   "innovate":"创新区",
   "myshop":"我的商铺",
   "order":"订单管理",
   "myc2c":"我交易的c2c",
   "usercenter":"个人中心",
   "myshare":"我的分享链接",
   "releasec2c":"发布c2c",
   "language":"言語",
   "security":"セキュリティセンター",
   "pay":"收款方式",
   "bindaddress":"绑定提币地址",
   "address":"アドレスを撤回する",
   "aboutus":"私たちに関しては",
   "logout":"ログアウト",
   "vol":"24H量",
   "jc":"JC兑换BEAU",
   "kjcb": "充電する",
   "zcbz": "BTC、USDT..."
 },
 "transaction":{
   "buy":"バイイン",
   "sell":"売る",
   "pwd":"交易密码",
   "inputpass":"输入交易密码",
   "inputnum":"输入数量",
   "limit":"制限",
   "avaiable":"利用可能",
   "turnover":"取引金額",
   "handicap":"ハンディキャップ",
   "number":"量",
   "nonumber":"未完成数量",
   "numbered":"已完成数量",
   "price":"価格",
   "marketprice":"市場価格",
   "cancel":"キャンセル",
   "total":"全站交易",
   "time":"時間",
   "nomore":"暂无更多",
   "nodata":"記録なし",
   "getmore":"加载更多",
   "mycommission":"我的委托",
   "currentbuy":"現在の手数料(买入)",
   "currentsell":"現在の手数料(卖出)",
   "his":"歴史委員会(完了)",
   "currency":"币种",
   "option":"操作",
   "wtime":"完成时间",
   "wnumber":"完成数量",
   "wprice":"完成价格"
 },
 "mk":{
   "high":"高",
   "low":"低",
   "vol":"24H量",
   "newPrice":"最新価格",
   "product":"产品",
   "name":"名前",
   "rank":"リストを増やす"
 },
 "deals":{
   "issue_time":"公開時間",
   "issue_number": "リリース数",
   "white_book": "白書",
   "weburl": "公式ウェブサイト",
   "video_url": "视频介绍",
   "introduction":"前書き",
   "onhand":"1手等于",
   "position": "当前持仓",
   "leverorder":"杠杆下单",
   "leverposition":"杠杆持仓",
   "inputprice":"输入价格",
   "inputmul":"输入倍数",
   "selectmul":"选择倍数",
   "onehand":"1手等于",
   "hand":"交易手数",
   "marketval":"合约市值",
   "bond":"保证金",
   "service":"服务费",
   "balance":"余额",
   "type":"类型",
   "risk":"风险率",
   "total":"持仓总盈亏：",
   "onekey":"一键平仓",
   "makemore":"(做多)",
   "makeless":"(做空)",
   "current":"現在の手数料",
   "all":"全て",
   "weing":"委托中",
   "tding":"交易中",
   "ping":"平仓中",
   "pied":"閉まっている",
   "ceiled":"注文がキャンセルされました",
   "weprice":"委托价",
   "oprice":"开仓价",
   "nowprice":"当前价",
   "zyprice":"止盈价",
   "zsprice":"止损价",
   "canbond":"可用保证金",
   "optime":"开仓时间",
   "pgtime":"平仓时间",
   "znum":"折合数量",
   "gprice":"隔夜费",
   "pcang":"清算",
   "revoke":"キャンセル",
   "fee":"手数料",
   "you":"以当前最优价格交易"
 },
 "assets":{
   "bzxz":"币种选择",
   "copy": "复制",
   "currency":"币币",
   "lever":"合约",
   "legal":"法币",
   "curAccount":"币币账户",
   "total":"資産変換(USDT)",
   "leverAccount":"合约账户",
   "legalAccount":"法币账户",
   "avaiable":"利用可能",
   "lock":"冻结",
   "conversion":"変換済み",
   "exact":"交易账户",
   "transfer":"划转",
   "num":"量",
   "time":"時間",
   "record":"记录",
   "caidata":"财务记录",
   "from":"从",
   "to":"到",
   "transnum":"划转数量",
   "all":"全て",
   "canuse":"利用可能",
   "pmin":"请输入最低划转数量",
   "cmoney":"預入",
   "tmoney":"撤退",
   "caddress":"充币地址",
   "copyaddress":"复制地址",
   "a01":"请勿向上述地址充值任何非",
   "a02":"资产，",
   "a03":"否则资产将不可找回。",
   "a04":"充币仅支持simple send的方法，使用其他方法的充币暂时无法上账，请您谅解。",
   "a05":"您充值至上述地址后，需要整个网络节点的确认，1次网络确认后到账，6次网络确认可提币。",
   "a06":"最小充值金额：",
   "a07":"小于最小金额的充值将不会上账且无法退回。",
   "a08":"您的充值地址不会经常改变，可以重复充值;如有更改，我们会尽量通过网络公告或邮件通知您。",
   "a09":"请务必确认电脑及浏览器安全，防止信息被篡改或泄露。",
   "taddress":"アドレスを撤回する",
   "taddressm":"引き出し先住所を入力してください",
   "padd":"输入或长按粘贴地址",
   "rate":"手数料",
   "dnum":"到着数量",
   "more":"加载更多",
   "nodata":"記録なし",
   "search":"搜索币种",
   "yczc":"0として非表示のアセット"
 },
 "td":{
   "drecord":"订单记录",
   "orecord":"已完成订单记录",
   "filter":"筛选",
   "tdtype":"交易类型",
   "buy":"购买",
   "sell":"出售",
   "wantbuy":"求购",
   "dstatus":"注文の状況",
   "nofinish":"未完成",
   "finished":"完了",
   "ceiled":"已取消",
   "payed":"已付款",
   "waitPay":"待付款",
   "reset":"重置",
   "confirm":"決定する",
   "time":"時間",
   "num":"量",
   "tdtotal":"交易总额",
   "call":"联系对方",
   "buyer":"买家",
   "seller":"卖家",
   "Sprice":"单价",
   "price":"価格",
   "ptime":"注文時間",
   "cnum":"参考号",
   "tdceil":"取消交易",
   "sureReceive":"确认已收款",
   "conPay":"付款确认",
   "ppay":"请付款",
   "paynext":"请向以下账户付款",
   "tdPrice":"交易单价",
   "tdNum":"交易数量",
   "payInfo":"付款信息",
   "accountInfo":"账号信息",
   "receiver":"收款人",
   "open":"开户行",
   "pcnum":"打款时请务必填写参考号",
   "imPay":"我已付款,点击确认",
   "tdAttion":"交易提醒",
   "odCeil":"取消订单",
   "at01":"您的汇款将直接进入卖家账户,交易过程中卖家出售的数字资产由平台托管保护。",
   "at02":"请在规定时间内完成付款，并务必点击“我已付款”，卖家确认收款后，系统会将数字资产划转到您的账户。",
   "at03":"如果买家当日取消订单达3次，将会被限制当日的买入功能。",
   "sureImpay":"请确认您已向卖家付款",
   "badClick":"恶意点击将直接冻结账户",
   "notpay":"我还没有付款给对方",
   "sureDpay":"请确认买家已向您付款",
   "sureCeil":"确认取消交易",
   "notCeil":"如果您已向卖家付款，请千万不要取消交易",
   "dover":"订单已完成，无法查看支付信息",
   "cover":"订单已取消，无法查看支付信息",
   "payFast":"付款确认后请尽快向卖家付款",
   "payClick":"如您已向卖家转账付款，请务必点击右下角“我已付款”按钮，否则有可能造成资金损失。",
   "pwait":"请等待买家付款",
   "pwd":"交易密码",
   "ppwd":"トランザクションパスワードを入力してください",
   "sure":"決定する",
   "alipay":"支付宝",
   "wechat":"微信",
   "bank":"银行卡",
   "realName":"実名",
   "knum":"卡号",
   "pprice":"请输入单价",
   "pnum":"数量を入力してください",
   "min":"最小交易量",
   "pmin":"请输入最小交易量",
   "max":"最大交易量",
   "pmax":"请输入最大交易量",
   "buyNum":"购买数量",
   "currency":"币种",
   "pmethod":"请选择支付方式",
   "choose":"请选择",
   "mysells":"我的出售",
   "mybuys":"我的求购",
   "pcoin":"请选择货币单位"
 },
 "fat":{
   "mybuy":"我要买",
   "mysell":"我要卖",
   "ceil":"キャンセル",
   "buy":"购买",
   "sell":"出售",
   "forsell":"出售需求",
   "forbuy":"购买需求",
   "price":"单价",
   "bprice":"按价格购买",
   "bnum":"按数量购买",
   "pbtotal":"请输入欲购买法币总额",
   "pstotal":"请输入欲出售法币总额",
   "pbnum":"请输入欲购买数量",
   "psnum":"请输入欲出售数量",
   "allbuy":"全部买入",
   "allsell":"全部卖出",
   "limit":"限额",
   "tdtotal":"交易总额",
   "autoceil":"s自动取消",
   "num":"量",
   "submit":"下单",
   "pwd":"交易密码",
   "ppwd":"トランザクションパスワードを入力してください",
   "sure":"注文を確認する",
   "reTime":"认证商家 | 注册时间 ",
   "release":"发布",
   "allOrder":"总成单",
   "dayOrder":"30日成单",
   "overOrder":"完成单",
   "rate":"完成率",
   "auPhone":"手机认证",
   "auName":"確認済み",
   "auHigh":"高级认证",
   "sellLine":"在线出售",
   "buyLine":"在线购买",
   "myshop":"我的商铺",
   "mybalance":"商家余额"
 },
 "auth":{
   "bh": "驳回",
   "bhr": "您的申请被驳回，原因如下：",
   "mycenter":"个人中心",
   "test":"身份验证",
   "gotest":"去认证",
   "testing":"审核中",
   "tested":"已认证",
   "t1":"认证后可提升提币额度",
   "t2":"认证后可进行c2c交易",
   "t3":"认证后可进行法币交易",
   "name":"姓名",
   "account":"账户",
   "number":"证件号",
   "pname":"请输入姓名",
   "pnum":"请输入证件号",
   "id_card_face": "请上传身份证正面",
   "id_card_back": "请上传身份证反面",
   "upimg":"请上传证件正反面，以及手持证件照正面照片。",
   "updata":"提交",
   "updata_again":"重新提交"
 },
 "code":{
   "mycode":"我的推广码",
   "code":"推广码",
   "qrcode":"扫上面的二维码图案或输入推广码，确认注册",
   "notice":"発表",
   "about":"相关新闻"
 },
 "safe":{
   "title":"账户安全",
   "center":"セキュリティセンター",
   "qchc":"キャッシュの消去",
   "yysz":"言語設定",
   "ssms":"ダークモード",
   "gywm":"私たちに関しては",
   "lgpwd":"ログインパスワード",
   "tkmm":"提币密码",
   "paypwd":"支付密码",
   "resetpwd":"修改密码",
   "paccount":"请输入手机号或邮箱",
   "next":"下一步",
   "reset":"修改",
   "stest":"安全验证",
   "ceil":"キャンセル",
   "pcode":"検証コード",
   "send":"发送",
   "sure":"确认",
   "newPwd":"重新设置密码",
   "len":"密码需要6-20个字符",
   "ppwd":"パスワードを入力してください",
   "reppwd":"请再次输入密码",
   "repwd":"重置密码",
   "zpwd":"交易密码"
 },
 "met":{
   "add":"添加方式",
   "open":"开户行名称",
   "bank":"銀行口座",
   "realname":"実名",
   "alipay":"支付宝账号",
   "wename":"微信昵称",
   "wechat":"微信账号",
   "save":"保存",
   "popen":"请输入开户行名称",
   "pbank":"请输入开户行账号",
   "pname":"本名を入力してください",
   "palipay":"请输入支付宝账号",
   "pwename":"请输入微信昵称",
   "pweaccount":"请输入微信账号"
 },
 "ads":{
   "tas":"アドレスを撤回する",
   "address":"地址",
   "noads":"您还没有地址",
   "adds":"地址",
   "padd":"提币或粘贴地址",
   "remark":"备注",
   "cel":"删除"
 },
 "call":{
   "callme":"联系我们",
   "Privacy":"隐私政策"
 },
 "jc":{
   "title":"JC积分兑换BEAU平台",
   "bind":"绑定账号",
   "balance":"JC余额",
   "cannum":"可用JC数量:",
   "new":"BEAU最新价:",
   "exnum":"兑换数量:",
   "pnum":"请输入JC数量",
   "canex":"可兑换BEAU数量:≈",
   "exnow":"立即兑换",
   "record":"兑换记录",
   "exprice":"兑换价格:",
   "extime":"兑换时间",
   "not":"可用积分数量不足",
   "usenum":"使用JC数量",
   "paccount":"请输入账号",
   "ppwd":"パスワードを入力してください",
   "gotd":"去交易"
 },
 "lg":{
   "welcome":"こんにちは！ログインしてください",
   "hsa": "已有账号?",
   "lgs":"ログインする",
   "lgbt":"ログインする",
   "lgtel":"手机登陆",
   "lgeml":"邮箱登陆",
   "paccount":"電話番号または電子メール",
   "ppwd":"パスワードを入力してください",
   "ppwd2":"パスワードを確認してください",
   "pcode":"検証コード",
   "qsryqm": "招待コードを入力してください",
   "mepwd":"记住密码",
   "noaccount":"アカウントはまだありませんか？",
   "qregister":"登録に移動",
   "register":"登録済み",
   "phregister":"お使いの携帯電話を登録します",
   "emregister":"メール登録",
   "noset":"注册后不能修改",
   "pphone":"携帯電話番号",
   "next":"下一步",
   "have":"已有账号？",
   "ceil":"キャンセル",
   "msgtest":"短信验证",
   "send":"確認コードを取得する",
   "sure":"決定する",
   "email":"電子メールアドレス",
   "emtest":"Eメールによる確認",
   "scode":"確認コードを送信する",
   "pemcode":"検証コード",
   "ppcode":"検証コード",
   "ftpwd":"パスワードを忘れましたか？",
   "ftpwds":"パスワードを忘れましたか",
   "ptext":"電話番号またはメールアドレスを入力してください",
   "safetest":"安全验证",
   "sjh":"電話番号",
   "yzm":"検証コード",
   "mm":"パスワード",
   "qrmm":"パスワードを認証する",
   "mmcd":"密码长度8-12位",
   "language":"言語",
   "kjzc": "迅速な登録についてはお問い合わせください",
   "kjzc1": "キャプチャを受信できませんか？",
   "kjzc2": "クイック登録",
   "wyzx": "もう知っている",
   "qtxyxzh": "重要: パスワードの取得に使用できる有効なメールアドレスまたは携帯電話番号を入力してください"
 },
 "gjrz":{
   "title":"二次認証",
   "t1":"1. 8M未満のJPG、JPEG、またはPNG形式の画像をサポートします。",
   "t2":"2. ID写真の要件は明確であり、変更や妨害は許可されていません。また、ポートレート、ID番号、名前がはっきりと見える必要があります。",
   "t3":"3.写真にはキャップがなく、化粧は不要であることが推奨されます。IDを保持している人の顔の特徴がはっきりと見え、腕が無傷で露出している必要があります。",
   "t4":"決定する",
   "bh":"拒絶",
   "shz":"審査中",
   "shtg":"承認済み",
   "nyrzcg":"您已认证成功",
   "sczjz":"身分証明書の写真をアップロード",
   "sczjzmz": "IDの正面写真をアップロードします",
   "sczjbmz": "IDの裏側の写真をアップロードしてください",
   "scgrqmz": "IDと個人の署名写真をアップロードする"
 },
 "chongzhi":{
   "title":"充電する",
   "cbjl": "預金記録",
   "t1":"量",
   "t2":"数量を入力してください",
   "t3":"バウチャーの説明(オプション)",
   "t4":"説明を入力してください",
   "t5":"バウチャー画像",
   "t6":"決定する",
   "t7":"チェーン名",
   "t8":"QRコード",
   "t9":"QRコードを保存する",
   "t10":"預金住所",
   "t11":"复制",
   "zy": "重要",
   "tips1": "この通貨以外の資産を上記住所に追加しないでください。資産の出金ができなくなります",
   "tips2": "1.ウォレット/プラットフォームの互換性：つまり、ネットワークがサポートされています。ターゲットプラットフォームが引き出しネットワークをサポートしていない場合、アセットを取得できません。",
   "tips3": "2.トップアップネットワークとターゲットプラットフォームは同じです。ターゲットアドレスを選択した場合はイーサリアムネットワークですが、トップアップがTRC20スマートチェーンを選択した場合、デジタル資産を取得できない可能性があります。",
   "tips4": "3.再充電する前に、住所と金額が正しいことを確認してください。",
   "tips5": "注意：ブロックネットワークの匿名性とプライバシーのため、間違った情報を入力すると、対応するアセットが失われます。充電先住所と数量をよく確認してください"
 },
 "tibi":{
   "title":"撤退",
   "tbjl":"撤退記録",
   "t1":"アドレスを撤回する",
   "t2":"引き出し先住所を入力してください",
   "t3":"引き出し数",
   "qsrtbsl":"出金金額を入力してください",
   "t4":"最小引き出し",
   "t5":"トランザクションパスワード",
   "t6":"トランザクションパスワードを入力してください",
   "t7":"費用",
   "t8":"到着数量",
   "t9":"決定する",
   "sc":"删除",
   "bj":"编辑",
   "bq": "ラベル(Memo)",
   "qsrbq":"ラベルを入力してください",
   "yhktx":"銀行カードの引き出し",
   "yhmc": "銀行名",
   "qsryhmc": "銀行名を入力してください",
   "yhzh": "銀行口座",
   "qsryhzh":"銀行口座番号を入力してください",
   "gjhkdm": "国際送金コード",
   "qsrgjhkdm":"国際送金コードを入力してください",
   "yhdz": "銀行の住所",
   "qsryhdz":"銀行の住所を入力してください",
   "skrxm": "支払者名",
   "qsrskrxm":"お支払い受取人の名前を入力してください",
   "skrdh": "受取人の電話",
   "qsrskrdh":"お支払い受取人の電話番号を入力してください",
   "skrdz": "受取人の住所",
   "qsrskrdz":"受取人の住所を入力してください"
 },
 "huazhuan":{
   "title":"USDT划转",
   "t1":"币币账户余额",
   "t2":"合约账户余额",
   "t3":"划转数量",
   "t4":"请输入数量",
   "t5":"划转方向",
   "t6":"从",
   "t7":"币币账户",
   "t8":"至",
   "t9":"合约账户",
   "zf": "支付",
   "ky": "利用可能",
   "dd": "得到",
   "qbdh": "全部兑换",
   "t10":"決定する"
 },
 "banner":{
   "title": "詳細"
 },
 "download":{
   "t1": "いつでもどこでも取引",
   "xz": "ダウンロード"
 },
 "xgdlmm":{
   "title": "ログインパスワードを変更する",
   "zh":"アカウント",
   "zhts":"携帯電話またはメール",
   "yzm":"検証コード",
   "yzmts":"検証コード",
   "hqyzm":"確認コードを取得する",
   "mm":"パスワード",
   "mmts":"パスワードの長さ6〜12桁",
   "qrmm":"パスワードを認証する",
   "send":"发送",
   "qr":"確認"
 },
 "sztkmm":{
   "title":"トランザクションパスワードを設定する",
   "dlmm":"ログインパスワード",
   "dlmmts":"パスワードを入力してください",
   "xmm":"新密码",
   "mmts":"パスワードの長さ6桁",
   "qrmm":"パスワードを認証する",
   "qr":"確認",
   "qd": "決定する",
   "sztkts": "ヒント：セキュリティセンターにアクセスして、トランザクションパスワードを設定してください"
 },
 "rule":{
   "title":"ルール",
   "title2":"",
   "title3":"ルール"
 },
 "news":{
   "title":"私のメッセージ",
   "ckxq":"もっと",
   "gg":"発表"
 },
 "xsbk":{
   "title":"新手必看"
 },
 "search":{
   "qx":"キャンセル",
   "rmss":"热门搜索"
 },
 "wdtg":{
   "title": "友達を招待",
   "yq": "コミッションを獲得する",
   "zyj": "",
   "wdyqlj":"私の招待リンク",
   "wdyqm":"私の招待コード",
   "schbyq":"ポスターの招待状を生成する",
   "ljtgsy":"累计推广收益",
   "ljkh":"累计客户(人)",
   "tkrs":"招待の数",
   "ljyj":"累積手数料",
   "yjmx":"委員会の詳細",
   "ljyjjl":"累计佣金奖励(usdt)",
   "ljsy":"累積所得",
   "ljyqjl":"累计邀请奖励(usdt)",
   "fxd":"共有する",
   "wxhy":"微信好友",
   "wxpyq":"微信朋友圈",
   "bctp":"画像を保存する",
   "qx":"キャンセル",
   "t1": "コイン投機、鉱業",
   "t2": "利益はすべてあなたのものです",
   "t3": "画像を長押しして認識またはスキャンします"
 },
 "bzhl":{
   "title":"配当",
   "gz":"ルール",
   "tgdd":"托管订单",
   "zztgdzj":"保管中の資金",
   "yjjrsy":"毎日推定",
   "ljsy":"累積所得",
   "tgzdd":"エスクローでの注文",
   "cljxcp":"策略竞选产品",
   "dbxe":"単一の制限",
   "rsyl":"日收益率",
   "zq":"周期",
   "qmr":"今買う",
   "bbzhzc": "账户资产",
   "zcc": "总持仓(USDT)",
   "dd":"订单",
   "buy":"バイイン",
   "jxcp":"精选产品",
   "ckdd":"注文を確認する",
   "gd":"更多",
   "xzbzts": "シンプルで安全。 配当は複数の通貨で選択できます",
   "qtbz": "その他のコイン"
 },
 "bzhlgm":{
   "title":"搬砖获利",
   "bzhld":"搬砖获利得usdt",
   "qtzq":"USDT7天周期",
   "rsyl":"毎日の返品率(%)",
   "lczq":"理财周期",
   "dbxe":"単一の制限",
   "pxsj":"配当時間",
   "mr":"毎日",
   "dqfh":"到期返还",
   "tgzj":"エスクロー資金",
   "tqsh":"引き出しと償還",
   "yjsy":"预计收益(USDT)",
   "kyzc":"可用资产(USDT)",
   "cpjs":"製品説明",
   "tgje":"エスクロー金額",
   "qsrtgje":"请输入托管金额",
   "qb":"全て",
   "rm":"今買う",
   "cpzq":"製品寿命",
   "jxr":"计息日",
   "jiexr":"结息日",
   "yjdzr":"预计到账日",
   "gz":"ルールと利益を理解する"
 },
 "bzhlwdtg":{
   "title":"注文の状況",
   "tgz":"ホスティング",
   "ywc":"完了",
   "ysh":"償還",
   "tgje":"エスクロー金額/期間日",
   "rsyl":"収益性の高い/残りの日数",
   "yhl":"収益性の高い/残りの日数",
   "xdsj":"注文時間",
   "sh":"赎回",
   "ddxq":"注文詳細",
   "ddh":"订单号"
 },
 "bzjj":{
   "t1": "天天赚不停",
   "t2": "搬砖是通过将USDT托管给平台，由平台的专业团队进行搬砖权利，参与者在资金托管期间可获得平台的搬砖收入分成",
   "cpld": "製品のハイライト",
   "scsq": "入金して受け取る",
   "pxzq": "派息周期",
   "mtxf": "毎日発行",
   "hqlx": "活期利息",
   "zj": "100%资金",
   "aqbz" :"セキュリティ",
   "jjrsy": "节假日收益",
   "sybjd":"途切れない収益",
   "bjd": "不间断",
   "cgcrh": "成功存入后",
   "dtqx": "当天起息",
   "jglz": "举个例子",
   "syjs": "收益计算",
   "cont1": "会员在平台存入了10000U，选择了周期为七天，日收益率为0.3%~0.5%的理财产品，则每天的收益如下：",
   "cont2": "最低：10000U× 0.3%-30U",
   "cont3": "最高：10000U× 0.5%-50U",
   "cont4": "既：7天后可以获得210U-350U的收益，收益每日下发，下发的收益可随时存取，存入的本金，到期满后，自动返回自您的钱包账户。",
   "gywyj": "关于违约金",
   "cont5": "若您希望转出未到期的本金，则会产生违约金，违约金=违约结算比例*剩余天数*投资数量。",
   "cont6": "举例：该产品的违约结算比例为0.4%，剩余3天到期，投资数量为1000，则违约金=0.4%*3*1000=12U，实际退还本金为1000U-12U=988U",
   "wycy": "我要参与"
 },
 "zyzs":{
   "title":"利益を上げて損失を止める",
   "zy":"止盈",
   "zs":"ストップロス",
   "qsrzyjg":"テイクプロフィット価格を入力してください",
   "qsrzsjg":"ストップロス価格を入力してください",
   "cfjglx":"トリガー価格タイプ：",
   "zsjg":"指数価格",
   "scjg":"市場価格",
   "pcfs":"クロージング方法：",
   "kpcw":"閉位置",
   "qbcw":"すべてのポジション",
   "wxts":"チップ：",
   "cont": "市場が閉鎖されると、激しい市場変動により成行注文が失敗し、ストッププロフィットとストップロスが成功しない可能性があります。",
   "qr":"確認"
 },
 "bbjy":{
   "mr":"バイイン",
   "mc":"売る",
   "mai":"購入",
   "sell":"販売",
   "xj":"制限",
   "sj":"市場価格",
   "pk":"ハンディキャップ",
   "jg":"価格",
   "sl":"量",
   "mrl":"买入量",
   "ss":"量",
   "mcl":"卖出量",
   "ky":"利用可能",
   "km":"買える",
   "ksell":"ホールディング",
   "jye":"取引金額",
   "dqwt":"現在の手数料",
   "lswt":"歴史委員会",
   "jj":"前書き",
   "wtzl":"合計",
   "wtjg":"手数料価格",
   "ycjl":"已成交量",
   "cjjj":"成交均价",
   "cd":"キャンセル",
   "xd":"下单",
   "ywc":"完了",
   "ycd":"キャンセル",
   "wqcj":"完全成交",
   "zx":"オプション",
   "scjg":"市場価格",
   "fhsj":"公開時間",
   "fhsl":"リリース数",
   "bps":"白書",
   "gw":"公式ウェブサイト",
   "qx":"キャンセル"
 },
 "hyjy":{
  "mai":"購入",
  "sell":"販売",
   "kc":"ポジションを開く",
   "pc":"清算",
   "cc":"ポジション",
   "kp":"可平",
   "kpc":"平らにすることができます",
   "kcc":"可持仓",
   "kkd":"可开多",
   "kpd":"Pingdoできますか",
   "kkk":"可开空",
   "xj":"制限",
   "sj":"市場価格",
   "xjwt":"指値注文",
   "sjwt":"成行注文",
   "pk":"ハンディキャップ",
   "jg":"価格",
   "sl":"量",
   "gg":"レバー",
   "tzgg":"レバレッジを調整する",
   "ggbs": "レバレッジ",
   "mrl":"买入量",
   "ky":"利用可能",
   "jye":"取引金額",
   "dqwt":"現在の手数料",
   "lswt":"歴史委員会",
   "ptwt":"普通委托",
   "dqwtmr":"現在の注文（購入）",
   "dqwtmc":"現在の注文（販売）",
   "hywt":"合约委托",
   "jj":"前書き",
   "wtzl":"合計",
   "wtjg":"手数料価格",
   "ycjl":"已成交量",
   "cjjj":"成交均价",
   "cd":"キャンセル",
   "xd":"下单",
   "qbcd":"すべての注文をキャンセルする",
   "wqcj":"完全成交",
   "ywc":"完了",
   "ycd":"注文がキャンセルされました",
   "zx":"オプション",
   "scjg":"市場価格",
   "fhsj":"公開時間",
   "fhsl":"リリース数",
   "bps":"白書",
   "gw":"公式ウェブサイト",
   "mrzd":"买入做多",
   "mrpk":"买入平空",
   "mczk":"卖出做空",
   "mcpd":"卖出平多",
   "mrkdkz":"ロングオープン（強気）を買う",
   "mrpkkz":"ショート（強気）を買う",
   "mckkkd":"オープンショート（弱気）を売る",
   "mcpdkd":"フラットロング（弱気）を売る",
   "yxhy":"永久契約",
   "dc":"多仓",
   "kcjj":"开仓均价(BUSDT)",
   "wsxyl":"未实现盈利(BUSDT)",
   "ygqpj":"预估强评价(BUSDT)",
   "syl":"收益率",
   "cwbzj":"仓位保证金(BUSDT)",
   "cw":"仓位(张)",
   "cwjz":"仓位价值(BUSDT)",
   "bzjl":"マージン",
   "kpz":"可平(张)",
   "bdzs":"标的指数",
   "tzbzj":"调整保证金",
   "zyzs":"利益を上げて損失を止める",
   "zjbzj":"增加保证金",
   "jsbzj":"减少保证金",
   "tyhy":"体验合约",
   "ccz":"ポジション(张)",
   "cwbzjt":"仓位保证金(TBTC)",
   "zdzjbzj":"最多增加保证金(TBTC)",
   "zjbzjt":"增加保证金(TBTC)",
   "zhang":"量",
   "qblx":"いろんなタイプ",
   "qb":"全て",
   "ccjg":"ポジション価格",
   "ccsl":"ポジション数",
   "yk":"利益と損失",
   "ccsj":"待ち時間",
   "zy":"止盈",
   "zs":"ストップロス",
   "zje":"合計金額",
   "kcs":"オープンポジションの数",
   "kcjg":"始値",
   "ss":"たくさん",
   "hand":"1ロット=",
   "qx":"キャンセル",
   "qr":"確認"
 },
 "kxt":{
   "gao":"H",
   "di":"L",
   "wtgd":"保留中の注文を委託する",
   "cj":"対処",
   "jj":"前書き",
   "sj":"時間",
   "fx":"方向",
   "jg":"価格",
   "sl":"量",
   "mr":"バイイン",
   "mc":"売る",
   "mp":"买盘",
   "sp":"卖盘",
   "slb":"量",
   "fhsj":"公開時間",
   "fhsl":"リリース数",
   "bps":"白書",
   "gw":"公式ウェブサイト",
   "fz":"min",
    "xs":"hour",
    "tian":"day",
    "zhou":"week",
    "yue":"month",
    "gd":"More",
   "ft":"副图",
   "zt":"主图",
   "sdt":"深度图",
   "zx":"オプション",
   "djck": "クリックして表示"
 },
 "zhjl":{
   "cbtb":"出し入れ",
   "jymx":"取引の詳細",
   "tgyj":"推广佣金",
   "wwc": "未完成",
   "ywc": "完了"
 },
 "zwsj":{
   "title":"データなし"
 },
 "bzxz":{
   "title":"通貨を選択してください"
 },
 "jghy":{
   "jghy": "配送契約",
   "yxhy": "パーペチュアル",
   "mz": "強気",
   "md": "弱気",
   "gmj": "購入金額",
   "jsj": "決済価格",
   "xj": "現在の価格",
   "fx": "方向",
   "sl": "量",
   "jgsj": "納期",
   "gb": "シャットダウン",
   "jxxd": "注文を続ける",
   "cclb": "ポジションリスト",
   "zc": "ホールディング",
   "lscc": "歴史的地位",
   "qblx": "いろんなタイプ",
   "yk": "利益と損失",
   "ddqr": "注文の確認",
   "dqsj": "有効期限",
   "jssj": "決済時間",
   "sy": "所得",
   "tzje": "投資額",
   "zdje": "投資額が0より大きい",
   "kyye": "残高: ",
   "kyye2": "残高",
   "sxf": "費用：",
   "sxfl": "費用",
   "jypz": "名前",
   "jyfx": "取引の方向性",
   "qrxd": "注文を確認する",
   "fs": "more",
   "dqye": "経常収支"
 },
 "kjmb":{
   "title":"暗号通貨",
   "gm": "购买USDT",
   "wxts": "温馨提示：",
   "wxts-copy": "请复制USDT地址，您需要使用该地址购买USDT。",
   "copy": "复制",
   "ljmb": "暗号通貨",
   "buy": "购买",
   "cs": "出售",
   "qx": "キャンセル",
   "gmsl": "购买数量",
   "cssl": "出售数量",
   "qsrgmsl": "请输入购买数量",
   "qsrcssl": "请输入出售数量",
   "qxzzffs": "请选择支付方式",
   "yhk": "银行卡",
   "wx": "微信",
   "zfb": "支付宝",
   "jg": "価格",
   "kyye": "残高：",
   "zxjysl": "最小交易数量：",
   "ts1": "1.买卖商家均为平台认证商家，提供24小时服务。",
   "ts2": "2.如订单产生纠纷，请立即联系客服进行处理。",
   "fzcg": "正常にコピー"
 },
 "tips":{
   "jymm": "トランザクションパスワード",
   "szjymm": "トランザクションパスワードを設定する",
   "qsrjymm": "トランザクションパスワードを入力してください",
   "jymmts": "请到安全中心设置交易密码"
 },
 "xyf":{
   "title": "クレジットスコア",
   "pgsj": "評価時間"
 },
 "dzrz":{
   "title": "アドレス認証",
   "sdddz":"公共料金の請求先住所",
   "tpsc": "請求書画像のアップロード",
   "ts": "注意：住所情報を入力し、公共料金請求書またはブロードバンド住所請求書を提出する必要があります",
   "tips":"住所情報を入力し、公共料金請求書またはブロードバンド住所請求書を提出する必要があります",
   "qsczdtp":"請求書画像のアップロード"
 },
 "newReg":{
   "sjh": "携帯電話",
   "yx": "Eメール",
   "yqm": "招待コード",
   "yqm2": "招待コード（オプション）",
   "cjzh": "アカウントを作成する",
   "sysjhzyx": "携帯電話番号/メールで登録",
   "sj": "携帯電話",
   "yhxy": "&lt;ーザー契約&gt;",
   "yhxy2": "およびユ&lt;ーザー契約&gt;を読み、同意します "
 },
 "mbwt":{
   "title": "セキュリティの問題",
   "mbwt": "セキュリティの問題",
   "qtxda": "お答えください",
   "qsrxmm": "新しいパスワードを入力してください",
   "sydqmmcz": "現行パスワードのリセットを使用する",
   "zhmm": "セキュリティの問題パスワードの取得",
   "ysz": "設定",
   "tg": "省略する",
   "tj": "送信する",
   "zyts": "重要：",
   "zytsCont": "秘密の回答と確認コードを開示しないでください。また、パスワードの取得に役立つセキュリティの問題に注意してください。"
 },
 "xbsg":{
   "title": "コイン購入",
   "wdsg": "詳細",
   "scts": "ロックアップ日：",
   "sy": "残り",
   "ljsg": "今すぐ購読",
   "ysk": "完売",
   "xzjdy": "今すぐ購読",
   "dy": "購読",
   "fxjg": "発行価格",
   "fxl": "サーキュレーション",
   "ssrq": "上場日",
   "yxqx": "有効期間",
   "qsrsl": "数量を入力してください",
   "syl": "残り",
   "sgrq": "購入日",
   "sgsl": "額",
   "bz": "コイン",
   "yebz": "不十分なUSDTバランス",
   "tgsl": "パス数量",
   "shz": "レビュー中",
   "wtg": "合格しなかった",
   "ytg": "合格しました"
 },
 "wydb":{
   "title": "借りる",
   "db": "借りる",
   "dbz": "借りる",
   "jl": "記録",
   "jdzq": "期間（日）",
   "qhk": "返済",
   "ljdb": "累積（usdt）",
   "dhkbs" :"支払い待ち",
   "jkje": "融資額（usdt）",
   "qsrje": "数量を入力してください",
   "rll": "毎日の金利",
   "hkfs": "返済",
   "dqych": "期限切れ",
   "lx": "興味",
   "fkjg": "貸し手",
   "tpsc": "クレジットローン(画像アップロード)",
   "fwxx": "住宅情報",
   "srzm": "収入の証明（雇用関係）",
   "yhmx": "銀行取引明細書",
   "zjz": "身分証明書の写真",
   "yd": "私は読んで同意しました",
   "xy": "ローン契約を申請する",
   "sqdb": "ローンチェーンに申し込む",
   "gb": "閉鎖",
   "qd": "わかった",
   "ts": "ローン契約の申し込みを確認してください",
   "dbjl": "記録",
   "hkhth": "注文コード",
   "wsh": "未レビュー",
   "yfk": "ローン",
   "sqrq": "適用時間",
   "zq": "サイクル",
   "dbsl": "リブの数",
   "zhke": "支払い合計額",
   "yhkxq": "返済の詳細",
   "bqyhk": "当期の返済額(USDT)",
   "hktips": "残高が十分であることを確認してください。残高が不足している場合は、最初に再充電してから返済してください",
   "bj": "主要",
   "jie": "借りる",
   "ljhk": "すぐに返済",
   "qcz": "預け入れる",
   "yebzqxcz": "残高が不足している場合は、最初に再充電してから返済してください",
   "znj": "延滞料",
   "yqts": "延滞日数"
 },
 "hkxq":{
   "dd":"注文",
   "fzhkdz":"返済先住所をコピーする",
   "hkxq": "返済の詳細",
   "zlx": "総利息",
   "zhk": "総返済",
   "hkjg": "返済機関",
   "qschkpz": "返済証明書をアップロードしてください",
   "hkpz": "返済証明書"
 },
 "bbjyNew":{
   "jylx": "の種類",
   "jyze": "額"
 },
 "indexNew":{
   "title": "TokenSwapをメインインターフェイスに追加します",
   "t1": "フルスクリーンエクスペリエンスへのクイックアクセス",
   "t2": "下のツールバーをクリックしてください",
   "t3": "を選択します",
   "t4": "ホーム画面に追加します",
   "t5": " TokenSwapのフルバージョンをデスクトップエクスペリエンスに追加",
   "t6": "お気に入りに追加",
   "t7": "ページで検索"
 },
 "bind":{
   "title": "電子メール認証",
   "ybd": "バウンド",
   "wbd": "アンバウンド",
   "yrz": "確認済み",
   "wrz": "未確認",
   "ts": "アカウントを保護するために、メールアドレスをバインドすることをお勧めします",
   "qsryxdz": "電子メールアドレス"
 },
 "status":{
  "statusText": ['失敗','処理されるのを待っています','成功'],
},
"tipsNew":{
 "wjmmts": "確認コードでパスワードを回復する",
 "qscpztp": "バウチャー画像をアップロードしてください",
 "emailgsts": "入力したメールボックスがルールを満たしていない",
 "telgsts": "入力した携帯電話番号の形式が間違っている",
 "lcmmbyz": "パスワードを確認してください",
 "zdsl": "最小数量 ",
 "sldydy": "以上の数量",
 "zxtzsl": "最小数量 ",
 "ddz": "待っています",
 "xs": "小时",
 "min": "最小額 ",
 "max": "最大額 ",
 "yebz": "残高不足です",
 "qsrss": "ロットを入力してください",
 "zdss": "最小ロット",
 "yjj": "拒否されました",
 "shz": "償還",
 "zwkfcz": "この通貨はまだリチャージ可能ではありません",
 "jiaoge": "配達",
  "zhang": "上昇",
  "die": "秋",
  "cjxnzh": "仮想アカウントを作成"
},
"langNew2":{
  "flzq": "報酬ハブ",
  "qdjl": "サインイン報酬",
  "mrqdjl": "毎日のログイン報酬",
  "qd": "ログイン",
  "yqd": "サインインしました",
  "hdgz": "イベントルール",
  "qdjl2": "チェックイン記録",
  "qdcg": "サインイン成功",
  "yhd": "取得",
  "lq": "受信",
  "dyt": "1日目",
  "det": "2日目",
  "dst": "3日目",
  "dsit": "4日目",
  "dwt": "5日目",
  "dlt": "6日目",
  "dqt": "7日目",
  "jxz": "進行中"
},
"langNew":{
  "kp": "オープニング",
  "zuoshou": "昨日受け取りました",
  "zg": "最高",
  "zd": "最低",
  "dqjg": "現在の価格",
  "pcjg": "終値",
  "gd": "未決注文",
  "gdj": "未決注文価格",
  "gdjg": "未決注文価格",
  "xfbzj": "必要な保証金: ",
  "ksrfw": "利用可能な入力範囲: ",
  "shou": "ロット",
  "fdjyk": "浮動純損益",
  "pcsl": "決算数量",
  "cx": "取り消す",
  "qrpc": "ポジションを閉じることを確認する",
  "sx": "フィルター",
  "cz": "リセット",
  "zdl": "知っていた",
  "kccg": "ポジションのオープンに成功！",
  "xzfx": "方向を選ぶ",
  "lx": "タイプ",
  "xgcc": "位置を変更する",
  "szzyzs": "ストッププロフィットとストップロスを設定する",
  "szhb": "暗号通貨",
  "gjs": "金属",
  "yy": "原油",
  "jy": "トレード",
  "jmhb": "暗号通貨",
  "gdsj": "未決注文時間",
  "gdsl": "未決注文数量",
  "fs": "time"
 }
}



// WEBPACK FOOTER //
// ./src/utils/lang/jp.js